import PropTypes from "prop-types";
import React from "react";
import { Route, Redirect } from "react-router-dom";

class PrivateRoute extends React.PureComponent {
  static get propTypes() {
    return {
      ...Route.propTypes,
      isAuthenticated: PropTypes.bool.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.renderRoute = this.renderRoute.bind(this);
  }

  renderRoute(props) {
    const { isAuthenticated, render, component: Component } = this.props;

    if (isAuthenticated) {
      if (Component) {
        return <Component {...props} />;
      }

      if (render) {
        return render(props);
      }

      throw new Error("component or render required prop.");
    }

    const to = {
      pathname: "/login",
      state: {
        nextLocation: props.location,
      },
    };

    return <Redirect to={to} />;
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const {
      isAuthenticated,
      render,
      component: Component,
      ...rest
    } = this.props;

    return <Route {...rest} render={this.renderRoute} />;
  }
}

export { PrivateRoute };
